<template>
  <loading-page v-if="fetchingBucket" />
  <div v-else-if="somethingWentWrong">
    Something went wrong. Please try again later.
  </div>
  <bucket-form v-else-if="bucket" />
</template>

<script>
import BucketForm from './bucket-form/BucketForm.vue'

export default {
  name: 'NewBucket',
  components: { BucketForm },
  data() {
    return {
      somethingWentWrong: false,
    }
  },
  computed: {
    fetchingBucket() { return this.$store.state.accountBuckets.gettingBucket },
    bucket() { return this.$store.state.accountBuckets.bucket },
  },
  created() {
    this.fetchAccounts()
  },
  methods: {
    getBucketModel(externalAccountId) {
      this.$store.dispatch('accountBuckets/getBucket', {
        accountId: this.$route.params.accountId || externalAccountId,
        name: 'model',
      })
        .catch(error => {
          if (error.response.status === 500) {
            this.somethingWentWrong = true
            return
          }
          this.$router.push({ name: 'buckets' })
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while getting bucket model.')
        })
    },
    fetchAccounts() {
      this.$store
        .dispatch('externalAccount/fetchAccounts')
        .then((res => {
          const accountId = res?.data?.result[0]?.id
          this.getBucketModel(accountId)
        }))
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors
              || 'Something went wrong while fetching all external accounts.',
          )
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
